// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__qxGyP","inputWrap":"Table_inputWrap__uyepL","col":"Table_col__2DkTa","bmiTooltip":"Table_bmiTooltip__3K68N"};